import outlets from './outlets'
import outlet from './outlet'
import products from './products'
import clientContext from './clientContext'
import tables from './tables'
import menuTrees from './menuTrees'
import checkouts from './checkouts'
import payments from './payments'
import companies from './companies'
import identityUsers from './identityUsers'
import tickets from './tickets'
import orderReceipt from './orderReceipt'
import orders from './orders'
import order from './order'
import preOrders from './preOrders'
import stations from './stations'
import checks from './checks'
import items from './items'
import salesGroups from './salesGroups'

const core = {
  products,
  outlets,
  outlet,
  clientContext,
  identityUsers,
  tables,
  menuTrees,
  checkouts,
  payments,
  companies,
  tickets,
  orderReceipt,
  orders,
  order,
  preOrders,
  stations,
  checks,
  items,
  salesGroups,
}

export default core
